import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate, useLocation, Link } from "react-router-dom";
import SafeIcon from "../common/SafeIcon";
import * as FiIcons from "react-icons/fi";
import logo from "../common/images/logo.png";

const { FiMenu, FiX } = FiIcons;

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const menuItems = [
    { name: "Accueil", target: "hero" },
    { name: "Formation", target: "formation" },
    { name: "Parcours", target: "parcours" },
    { name: "Financement", target: "financement" },
    { name: "Équipe", target: "equipe" },
    { name: "Ressources", link: "/ressources" },
    { name: "Questions / Réponses", link: "/faq" },
  ];

  const scrollToSection = (targetId) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <nav className={`fixed top-0 w-full bg-white/95 backdrop-blur-sm shadow-lg z-50 transition-all duration-300 ${isScrolled ? 'py-1' : 'py-0'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center ">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img
              src={logo}
              alt="FormateurPourAdulte.fr Logo"
              className={`w-auto object-contain transition-all duration-300 ${isScrolled ? 'h-16' : 'h-[12rem]'}`}
            />
            <div>
              {/* <div className="text-xs text-gray-600">Advocaci Groupe</div> */}
            </div>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8">
            {menuItems.map((item) =>
              item.link ? (
                <Link
                  key={item.name}
                  to={item.link}
                  className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors duration-200 no-underline"
                >
                  {item.name}
                </Link>
              ) : (
                <button
                  key={item.name}
                  onClick={() => scrollToSection(item.target)}
                  className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors duration-200 bg-transparent border-none cursor-pointer"
                >
                  {item.name}
                </button>
              )
            )}
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <button
              onClick={() => scrollToSection("contact-form")}
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors duration-200 cursor-pointer border-none"
            >
              Contact
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-700 hover:text-blue-600"
            >
              <SafeIcon icon={isOpen ? FiX : FiMenu} className="h-6 w-6" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="md:hidden bg-white border-t border-gray-200"
        >
          <div className="px-2 pt-2 pb-3 space-y-1">
            {menuItems.map((item) =>
              item.link ? (
                <Link
                  key={item.name}
                  to={item.link}
                  onClick={() => setIsOpen(false)}
                  className="block w-full text-left px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600 no-underline"
                >
                  {item.name}
                </Link>
              ) : (
                <button
                  key={item.name}
                  onClick={() => {
                    scrollToSection(item.target);
                    setIsOpen(false);
                  }}
                  className="block w-full text-left px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600 bg-transparent border-none cursor-pointer"
                >
                  {item.name}
                </button>
              )
            )}
            <button
              onClick={() => {
                scrollToSection("contact-form");
                setIsOpen(false);
              }}
              className="block w-full text-left bg-blue-600 text-white px-3 py-2 rounded-lg mt-4 cursor-pointer border-none"
            >
              Contact
            </button>
          </div>
        </motion.div>
      )}
    </nav>
  );
};

export default Navbar;
